import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@shared/services/translate';
import { StorageService, SharedChangesService, APIFacadeService, NextInterface, ErrorInterface, CompleteInterface, API_TYPES, ERROR_TYPES } from '@shared/services';
import { Client } from '@shared/models/client/client.class';
import { Branch } from '@shared/models/branches/branches.class';
import { CashRegister } from '@shared/models/cash-register/cash-register.class';
import { NotificationService } from '@shared/services/dialogs/notification.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
    selector: 'shopbox-bread-crumb-nav',
    templateUrl: './bread-crumb-nav.component.html',
    styleUrls: ['./bread-crumb-nav.component.scss'],
    providers: [APIFacadeService],
    imports: [MatButton, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, NgClass]
})
export class BreadCrumbNavComponent implements OnInit, OnDestroy {
  currentClient: Client;
  currentBranch: Branch;
  currentCashRegister: CashRegister;

  activeProgress: boolean = false;

  branches: Branch[] = [];
  cashRegisters: CashRegister[] = [];

  selfChanges: boolean = false;

  constructor(
    private _api: APIFacadeService,
    private _storage: StorageService,
    private _shareChanges: SharedChangesService,
    private _changeDetectRef: ChangeDetectorRef,
    private _notify: NotificationService,
    public translate: TranslateService
  ) {
    this.subscribeToApi();
    this.watchClient();
    this.watchBranchAndCashRegister();
   }

  ngOnInit() {
    this.resetAllData();
    this.getConstants();
    this.getBranchesData();
  }

  getConstants() {
    this.currentClient = this._storage.getCurrentClient();
    this.currentBranch = this._storage.getCurrentBranch();
    this.currentCashRegister = this._storage.getCurrentCashRegister();
    if (this.currentBranch && this.currentCashRegister) {
      this.cashRegisters = this.currentBranch.cashRegister;
    }
  }

  subscribeToApi() {
    this._api.subscribeToApi(this._changeDetectRef, 400);
    this._api.nextEmit.subscribe((res: NextInterface) => {
      this.nextFnApi(res.res, res.apiType);
    });
    this._api.errorEmit.subscribe((res: ErrorInterface) => {
      this.errorFnApi(res.error, res.errorType);
    });
    this._api.completeEmit.subscribe((res: CompleteInterface) => {
      this.completeFnApi(res.apiType);
    });
  }

  nextFnApi(res: any, type: API_TYPES) {
    switch(type) {
      case API_TYPES.GET_BRANCHES:
        this.setBranchesList(res);
        break;
    }
  }

  errorFnApi(error: any, type: ERROR_TYPES) {
    if (typeof error === 'string') {
      this._notify.show(error, null, null, true);
    } else if (type === ERROR_TYPES.NORMAL) {
      this._notify.show(error, null, null, true);
    }
    this.changeProgress(false);
  }

  completeFnApi(type: API_TYPES) {
    switch(type) {
      default:
        this.changeProgress(false);
        break;
    }
  }

  changeProgress(res: boolean) {
    this.activeProgress = res;
    this._changeDetectRef.markForCheck();
  }

  resetAllData() {
    this.branches = [];
    this.cashRegisters = [];
  }

  getBranchesData() {
    const branchSub = this._api.shopboxApiService.branchService.getBranches();
    this._api.apiType = API_TYPES.GET_BRANCHES;
    this._api.errorType = ERROR_TYPES.NORMAL;
    this._api.apiSubject.next(branchSub);
  }

  setBranchesList(res: any) {
    if (res && res.data && res.data.length > 0) {
      res.data.forEach(element => {
        const branch = new Branch(element);
        this.branches.push(branch);
      });
    }
  }

  watchClient() {
    const sub = this._shareChanges.currentClientChange.subscribe(() => this.ngOnInit());
    this._api.subscriptionList.add(sub);
  }

  setCurrentBranch(branch: Branch) {
    this.currentBranch = branch;
    if (branch && branch.cashRegister && branch.cashRegister[0]) {
      this.currentCashRegister = branch.cashRegister[0];
      this._storage.setCurrentBranch(this.currentBranch);
      this._storage.setCurrentCashRegister(this.currentCashRegister);
      this.selfChanges = true;
      this._shareChanges.currentBranchAndCashRegChange.next({branch: this.currentBranch, cashRegister: this.currentCashRegister});
      this._changeDetectRef.markForCheck();
    }
  }

  watchBranchAndCashRegister() {
    const sub = this._shareChanges.currentBranchAndCashRegChange.subscribe(() =>
    {
      if (!this.selfChanges) {
        this.ngOnInit();
      } else {
        this.selfChanges = false;
      }
    });
    this._api.subscriptionList.add(sub);
  }

  setCurrentCashRegister(cr: CashRegister) {
    this.currentCashRegister = cr;
    this._storage.setCurrentCashRegister(this.currentCashRegister);
    this.selfChanges = true;
    this._shareChanges.currentBranchAndCashRegChange.next({branch: this.currentBranch, cashRegister: this.currentCashRegister});
    this._changeDetectRef.markForCheck();
  }

  ngOnDestroy() {
    this._api.destroy();
  }

}
